import { createMutation } from 'react-query-kit';

import { privateApi } from 'api';

import { GetAgreementResult } from './GetGeneralStudentAgreement';
import { SerializedEditorState } from 'lexical';

export type UpdateGeneralStudentAgreementParams = {
    tenantId: string;
    data: {
        content: SerializedEditorState;
    }
};

export type UpdateGeneralStudentAgreementResult = GetAgreementResult;

async function updateGeneralStudentAgreement(params: UpdateGeneralStudentAgreementParams): Promise<UpdateGeneralStudentAgreementResult> {
    const { tenantId, data } = params;

    // make api call
    const result = await privateApi.patch<UpdateGeneralStudentAgreementResult>(`${import.meta.env.VITE_API_BASE_URL}/tenants/${tenantId}/agreements/general-student`, data);

    // return the data object
    return result.data;
}

const useUpdateGeneralStudentAgreement = createMutation({
    mutationFn: async (variables: UpdateGeneralStudentAgreementParams) => updateGeneralStudentAgreement(variables),
});

export { updateGeneralStudentAgreement, useUpdateGeneralStudentAgreement };
